import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class SmartOfferBundleShopType extends Cloneable {
    static NONE = new SmartOfferBundleShopType(0, "NONE");

    static _values = [
        new SmartOfferBundleShopType(1, "SIMPLE_PRODUCT"),
        new SmartOfferBundleShopType(2, "DOUBLE_PRODUCT"),
        new SmartOfferBundleShopType(7, "HOLIDAY_PRODUCT"),

        new SmartOfferBundleShopType(3, "LONG_OFFER"),
        new SmartOfferBundleShopType(4, "FIRST_OFFER"),
        new SmartOfferBundleShopType(5, "SNAKE_OFFER"),
        new SmartOfferBundleShopType(6, "PICK_ONE"),
        new SmartOfferBundleShopType(8, "LUCKY_OFFER"),
        new SmartOfferBundleShopType(9, "RAID_OFFER"),
        new SmartOfferBundleShopType(10, "STEP_UP"),
        new SmartOfferBundleShopType(11, "COLLECTION_START"),
        new SmartOfferBundleShopType(12, "COLLECTION_END"),
        new SmartOfferBundleShopType(13, "DAILY_ENERGY_BOOST"),
        new SmartOfferBundleShopType(14, "CARD_PACK_DEAL"),
        new SmartOfferBundleShopType(15, "PICK_ONE_ONLY")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, SmartOfferBundleShopType.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof SmartOfferBundleShopType) {
            return SmartOfferBundleShopType._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return SmartOfferBundleShopType.NONE.equal(value);
    }

    constructor(id = 0, name = "DEFAULT") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof SmartOfferBundleShopType) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleShopType());
        } else if (target instanceof SmartOfferBundleShopType) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleShopType, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});